// import Vue from 'vue'
import { deviceEnquire, DEVICE_TYPE } from '@/utils/device'
import { mapState } from 'vuex'

// const mixinsComputed = Vue.config.optionMergeStrategies.computed
// const mixinsMethods = Vue.config.optionMergeStrategies.methods

const mixin = {
  computed: {
  },
  methods: {
  }
}

const mixinDevice = {
  computed: {
    ...mapState({
      device: state => state.device
    })
  },
  methods: {
    isMobile() {
      return this.device === DEVICE_TYPE.MOBILE
    },
    isDesktop() {
      return this.device === DEVICE_TYPE.DESKTOP
    },
    isTablet() {
      return this.device === DEVICE_TYPE.TABLET
    }
  }
}

const AppDeviceEnquire = {
  mounted() {
    const { $store } = this
    // 媒体查询是设备判定的唯一真源：桌面浏览器缩小窗口同样切到移动布局。
    // （此前 enquire 的结果会被下面的 UA 嗅探无条件覆盖，导致"窄窗口永远是
    //  desktop 布局"，移动端样式在桌面浏览器上完全失效。）
    deviceEnquire(deviceType => {
      $store.commit('TOGGLE_DEVICE', deviceType)
    })
    // 仅当 matchMedia 不可用（极老浏览器）时才退回 UA 嗅探作初始值
    if (typeof window.matchMedia !== 'function') {
      const isMobileUA = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
      $store.commit('TOGGLE_DEVICE', isMobileUA ? 'mobile' : 'desktop')
    }
  }
}

export { mixin, AppDeviceEnquire, mixinDevice }
